import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Don't scroll to top for dashboard - it manages its own scroll position
    if (pathname === "/dashboard") {
      return;
    }
    
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
